import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";

@Component({
  selector: "app-status-dialog",
  standalone: false,
  templateUrl: "./status-dialog.component.html",
  styleUrl: "./status-dialog.component.css",
})
export class StatusDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<StatusDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router
  ) {}

  close() {
    this.dialogRef.close();
  }

  ChanageStatus() {
    this.dialogRef.close(true);
  }
}
